<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_316_2957"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="19"
    >
      <path d="M3 2.99997H21V22H3V2.99997Z" fill="white" />
    </mask>
    <g mask="url(#mask0_316_2957)">
      <path
        d="M17.522 7.90534C16.665 5.97716 14.7189 4.46891 12.501 4.46891C10.2788 4.46891 8.33498 5.98166 7.47998 7.90534C6.10473 7.94209 4.96973 9.06766 4.96973 10.4518C4.96973 11.8591 6.14185 13 7.5492 13H17.4528C18.8601 13 20.0322 11.8591 20.0322 10.4518C20.0322 9.06766 18.8972 7.94209 17.522 7.90534Z"
        class="stroke-current"
        stroke-width="1.33333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5216 7.9043L14.751 7.90336"
        class="stroke-current"
        stroke-width="1.33333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.50098 15L8.00098 16.25"
        class="stroke-current"
        stroke-width="1.33333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.501 15L12.001 16.25"
        class="stroke-current"
        stroke-width="1.33333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.001 18.25L9.50098 19.5312"
        class="stroke-current"
        stroke-width="1.33333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.501 18.25L14.001 19.5312"
        class="stroke-current"
        stroke-width="1.33333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.501 15L16.001 16.25"
        class="stroke-current"
        stroke-width="1.33333"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
